import { Routes } from "@angular/router";
import { NotAllowedComponent } from "../modules/customer/not-allowed/not-allowed.component";
import { AuthGuardService } from "../modules/auth/services/auth-guard.service";
import { Permissions } from "../modules/auth/permissions/permissions";


export const customerRoutes: Routes = [
    {
      path: '',
      component: NotAllowedComponent,
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_CUSTOMER] }
    },
];
